import { Alert, Box } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { getValidationErrorTranslation } from '@frontend/utils';
import { translateKey } from '../../../../translate';

export enum PatientSearchField {
    birthDate = 'birthDate',
    birthDateAndBsn = 'birthDateAndBsn',
    identifierSocialSecurity = 'identifierSocialSecurity',
    name = 'name',
}

function getAlertText(errors?: ValidationErrors, searchField?: PatientSearchField) {
    if (errors && errors.size > 0) {
        if (errors.has('noMatchDateBsn')) {
            return getValidationErrorTranslation(errors.get('noMatchDateBsn'));
        }
        if (errors.has('birthDate')) {
            return getValidationErrorTranslation(errors.get('birthDate'));
        }
    }
    const searchFieldError =
        searchField === PatientSearchField.birthDate
            ? translateKey('patient.noResultBirthdate')
            : searchField === PatientSearchField.identifierSocialSecurity
              ? translateKey('patient.noResultBsn')
              : translateKey('patient.noResultName');

    return !searchField
        ? translateKey('validation.noMatchPatientFilters')
        : searchField === PatientSearchField.birthDateAndBsn
          ? translateKey('validation.noMatchDateBsn')
          : translateKey('patient.noResult', searchFieldError);
}

export function NoPatientResultBar(props: { errors?: ValidationErrors; searchField?: PatientSearchField }) {
    return (
        <Box
            pb={6}
            px={6}
        >
            <Alert
                appearance="warning"
                hasIcon={true}
                noMargin={true}
            >
                {getAlertText(props.errors, props.searchField)}
            </Alert>
        </Box>
    );
}
